import { c as _c } from "react/compiler-runtime";
import { IconOnTheLeftWithContentLayout } from '@/app/(marketing-site)/mentoring/_layouts/IconOnTheLeftWithContentLayout';
import type { AdvancedMentoringProductDTO } from '@/backend/modules/payment/endpoints/mutations/stripe-checkout/input.dto/input.dto';
import { H4 } from '@/frontend/design-system/_marketing/typography/Heading/H4';
import { P3 } from '@/frontend/design-system/_marketing/typography/Paragraph/P3';
import { Switch } from '@/frontend/design-system/forms/Switch';
type CareerCoachingProps = {
  advancedMentoringProduct: AdvancedMentoringProductDTO;
  updateProduct: (updates: (prev: AdvancedMentoringProductDTO) => Partial<AdvancedMentoringProductDTO>) => void;
};
export function CareerCoaching(t0) {
  const $ = _c(9);
  const {
    advancedMentoringProduct,
    updateProduct
  } = t0;
  const customizedTasks = advancedMentoringProduct.careerCoaching;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <H4>Premium career coaching</H4>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = customizedTasks === 1;
  let t3;
  if ($[1] !== updateProduct) {
    t3 = () => updateProduct(_temp);
    $[1] = updateProduct;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t2 || $[4] !== t3) {
    t4 = <div className="flex items-center justify-between">{t1}<Switch checked={t2} onChange={t3} /></div>;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <P3>Opcja stworzona dla pracujących w branży IT, którzy chcą wyjść na wyższy poziom w swojej karierze. Networking, budowanie marki osobistej, optymalizacja CV i profili LinkedIn/GitHub, kształtowanie umiejętności prezentacji i zarządzania zespołem.</P3>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4) {
    t6 = <IconOnTheLeftWithContentLayout mainContent={t4}>{t5}</IconOnTheLeftWithContentLayout>;
    $[7] = t4;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
}
function _temp(prev) {
  return {
    careerCoaching: prev.careerCoaching === 1 ? 0 : 1
  };
}